import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { icons } from '../../../assets';
import { Tooltip } from 'antd';
// eslint-disable-next-line
export const UserPerfilSimiVR = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {

    const { arrayData } = useSelector((state) => state.table);
    const { typeAdmin } = useSelector((state) => state.auth)
    const [pointsUpper, setpointsUpper] = useState(0)
    const [timeTotalUser, setTimeTotalUser] = useState(0)
    const { proyectSelected } = useSelector((state) => state.vrlSlice);
    // const { proyects } = useSelector((state) => state.vrlSlice);
    const [pageSelected, setpageSelected] = useState(0)

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    // eslint-disable-next-line
    const [dataFilterPerUser, setFileterData] = useState([])

    const formatedDate = (date) => {
        const fecha = new Date(date);
        return fecha.toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }


    const userHighPoints = (dataFilterPerUser) => {
        const element = dataFilterPerUser.reduce((max, elemento) =>
            parseInt(elemento.puntaje) > parseInt(max.puntaje) ? elemento : max, { puntaje: '0/23' }
        );
        setpointsUpper(dataFilterPerUser.length ? element.puntaje : 0);
    }

    const userTimeTotal = (dataFilterPerUser) => {
        const sumaTiempoTotal = dataFilterPerUser.reduce((total, elemento) => {
            const minutos = parseInt(elemento.tiempo_total.split(' ')[0], 10);
            return total + minutos;
        }, 0);
        const horas = Math.floor(sumaTiempoTotal / 60);
        const minutosRestantes = sumaTiempoTotal % 60;

        setTimeTotalUser(horas + ":" + minutosRestantes)
    }


    const onchangePage = (next) => {
        setpageSelected(actual => {
            const suma = actual + next
            if (suma >= dataFilterPerUser.length) {
                return 0
            }
            if (suma <= -1) {
                return dataFilterPerUser.length - 1
            }
            else {
                return suma
            }

        })
    }

    const calculePoints = (response) => {
        response.forEach(item => {
            let count = 0
            item.puntaje = Object.entries(item).reduce((counter, [key, value]) => {
                if (value === "A") count++;
                return count
            }) + "/23"
        })
        return response
    }

    // const contarAprobados = (obj, keys) => {
    //     return keys.reduce((count, key) => count + (obj[key] === "Aprobado" ? 1 : 0), 0);
    // }

    useEffect(() => {

        // if (typeAdmin === "VRT" && proyectSelected === "66fafd1d92bbc20883798c43") {
        // console.log(arrayData)


        // historia 
        // marcaje 
        // aplicacion 
        const conjunts = arrayData
            .filter(obj => obj.matricula === matricula)
            .map(obj => ({
                ...obj,
                Fecha_y_hora: formatedDate(obj.Fecha_y_hora),

            }));

        console.log(conjunts)
        const ReduceResponses = []
        let sumIntent = {}
        let banderasteap = 1
        conjunts.forEach((item, i) => {
            if (Object.keys(item).some(clave =>
                clave.includes("Desafío_1")) && banderasteap === 1) {
                banderasteap++
                sumIntent = { ...item }
                return
            }
            if (Object.keys(item).some(clave =>
                clave.includes("Desafío_1")) && banderasteap === 2) {
                ReduceResponses.push(sumIntent)
                banderasteap = 2
                sumIntent = {}
                sumIntent = { ...item }
            }
            if (Object.keys(item).some(clave =>
                clave.includes("_Desafío_3_")) && banderasteap === 2) {
                ReduceResponses.push(sumIntent)
                banderasteap = 2
                sumIntent = {}
                sumIntent = { ...item }
            }

            if (Object.keys(item).some(clave =>
                clave.includes("Desafío_2")) && banderasteap === 2) {
                banderasteap++
                sumIntent = { ...sumIntent, ...item }
            }


            if (Object.keys(item).some(clave =>
                clave.includes("Desafío__3")) && banderasteap === 3) {
                banderasteap = 1
                sumIntent = { ...sumIntent, ...item }
                ReduceResponses.push(sumIntent)
                sumIntent = {}
            } else {
                if (Object.keys(item).some(clave =>
                    clave.includes("Desafío_2")) && banderasteap === 1) {
                    banderasteap++
                    sumIntent = { ...sumIntent, ...item }
                }
                if (Object.keys(item).some(clave =>
                    clave.includes("Desafío__3")) && banderasteap === 2) {
                    banderasteap = 1
                    sumIntent = { ...sumIntent, ...item }
                    ReduceResponses.push(sumIntent)
                    sumIntent = {}
                }
                else if (Object.keys(item).some(clave =>
                    clave.includes("Desafío__3")) && banderasteap === 1) {
                    banderasteap = 1
                    sumIntent = { ...sumIntent, ...item }
                    ReduceResponses.push(sumIntent)
                    sumIntent = {}
                }
            }
        })
        const responsesPointsCorrect = calculePoints(ReduceResponses)
        console.log(ReduceResponses)
        setFileterData(responsesPointsCorrect);
        userHighPoints(responsesPointsCorrect);
        userTimeTotal(responsesPointsCorrect)
    }, [responses, proyectSelected, arrayData, Fecha_y_hora, matricula, typeAdmin, nameUser])


    return (
        <div className='w-full h-full flex flex-col py-6 px-10'>
            <div className='pl-4 w-full h-5/12 flex items-center'>
                <div className='w-10 h-10 rounded-full flex justify-center items-center bg-blue-600 mr-4'>
                    <p className='text-white font-semibold text-xs'> {nameUser.split(" ")[0].substring(0, 2).toUpperCase()}</p>
                </div>
                <InfoUser title={"Nombre"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />
                {<InfoUser title={"Fecha"} text={new Date(Fecha_y_hora).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })} />}
            </div>
            <div className="pl-16 pt-6">
                <p className='text-black text-2xl font-semibold leading-5'>Curso: {proyectSelected.name}</p>
            </div>
            <div className='w-full  flex h-12 justify-center gap-x-8 py-3'>
                <div className='flex w-[210px]'>
                    <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Tiempo total invertido</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{timeTotalUser} hrs.</p>
                    </div>
                </div>
                <div className='flex w-[210px]'>
                    <img src={icons.shield} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Puntaje más alto</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{pointsUpper}</p>
                    </div>
                </div>

            </div>
            <div className="w-full flex justify-center items-center pt-4">
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(-1) }}
                        className='h-full flex justify-center items-center mr-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 transform rotate-180' alt="" />
                        </div>
                    </div>
                }
                {/*  */}
                <div className='w-[744px] h-[390px] rounded-3xl shadow-3xl py-8 px-4 '>
                    <div className='flex w-full gap-4 pb-4 '>
                        {/* <div className='flex gap-2'>
                            <img src={icons.initialDate} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868]'>Fecha inicial</p>
                                <p>{dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}</p>
                            </div>
                        </div> */}
                        <InfoIntent icon={icons.initialDate} title={'Fecha inicial'} data={dataFilterPerUser[pageSelected]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.endDate} title={'Fecha final'} data={dataFilterPerUser[pageSelected]?.Fecha_y_hora || 'Sin fecha'}></InfoIntent>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Estatus</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected] && Math.round(Object.keys(dataFilterPerUser[pageSelected]).filter(k => k.includes("Desafío")).length * 100 / 23) + "%" || 'Sin progreso'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected] && Math.round(Object.keys(dataFilterPerUser[pageSelected]).filter(k => k.includes("Desafío")).length * 100 / 23) + "%" || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected] && Math.round(Object.keys(dataFilterPerUser[pageSelected]).filter(k => k.includes("Desafío")).length * 100 / 23) < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Puntaje</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: (dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] * 100) / 23 + '%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] < 23 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <InfoIntent icon={icons.progress} title={'Progreso'} data={dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}></InfoIntent> */}
                        {/* <InfoIntent icon={icons.pointsSheld} title={'Puntaje'} data={dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}></InfoIntent> */}
                    </div>
                    <div className='w-full h-10 bg-3366FF rounded flex'>
                        <div className='w-4/12 flex justify-start items-center px-2'>
                            <p className='text-white font-bold text-xs'>Módulos</p>
                        </div>
                        <div className='w-8/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Lecciones</p>
                        </div>

                    </div>
                    {/* epp */}
                    <div className='h-[240px] overflow-y-auto'>
                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>Desafío 1 Multivitamínico</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Multivitamínico_-_Saluda']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Multivitamínico_-_Saluda'] === "A"} title={"001._Desafío_1_Multivitamínico_-_Saluda"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta'] === "A"} title={"002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta'] === "A"} title={"003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad'] === "A"} title={"004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad'] === "A"} title={"005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Multivitamínico_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Multivitamínico_-_Cierre_de_venta'] === "A"} title={"006._Desafío_1_Multivitamínico_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Multivitamínico_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Multivitamínico_-_Cierre_de_venta'] === "A"} title={"007._Desafío_1_Multivitamínico_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Multivitamínico_-_Agradece']} correct={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Multivitamínico_-_Agradece'] === "A"} title={"008._Desafío_1_Multivitamínico_-_Agradece"}></CubeIntent>

                            </div>
                        </div>
                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'> Desafío 1 Invernal</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Invernal_-_Saluda']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Invernal_-_Saluda'] === "A"} title={"001._Desafío_1_Invernal_-_Saluda"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Invernal_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Invernal_-_Escucha_y_pregunta'] === "A"} title={"002._Desafío_1_Invernal_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Invernal_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Invernal_-_Escucha_y_pregunta'] === "A"} title={"003._Desafío_1_Invernal_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Invernal_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Invernal_-_Resuelve_su_necesidad'] === "A"} title={"004._Desafío_1_Invernal_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Invernal_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Invernal_-_Resuelve_su_necesidad'] === "A"} title={"005._Desafío_1_Invernal_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Invernal_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Invernal_-_Cierre_de_venta'] === "A"} title={"006._Desafío_1_Invernal_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Invernal_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Invernal_-_Cierre_de_venta'] === "A"} title={"007._Desafío_1_Invernal_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Invernal_-_Agradece']} correct={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Invernal_-_Agradece'] === "A"} title={"008._Desafío_1_Invernal_-_Agradece"}></CubeIntent>

                            </div>
                        </div>
                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'> Desafío 1 Gastro</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Gastro_-_Saluda']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Gastro_-_Saluda'] === "A"} title={"001._Desafío_1_Gastro_-_Saluda"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Gastro_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Gastro_-_Escucha_y_pregunta'] === "A"} title={"002._Desafío_1_Gastro_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Gastro_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Gastro_-_Escucha_y_pregunta'] === "A"} title={"003._Desafío_1_Gastro_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Gastro_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Gastro_-_Resuelve_su_necesidad'] === "A"} title={"004._Desafío_1_Gastro_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Gastro_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Gastro_-_Resuelve_su_necesidad'] === "A"} title={"005._Desafío_1_Gastro_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Gastro_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Gastro_-_Cierre_de_venta'] === "A"} title={"006._Desafío_1_Gastro_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Gastro_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Gastro_-_Cierre_de_venta'] === "A"} title={"007._Desafío_1_Gastro_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Gastro_-_Agradece']} correct={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Gastro_-_Agradece'] === "A"} title={"008._Desafío_1_Gastro_-_Agradece"}></CubeIntent>

                            </div>
                        </div>

                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'> Desafío 1 Analgesia</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Analgesia_-_Saluda']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío_1_Analgesia_-_Saluda'] === "A"} title={"001._Desafío_1_Analgesia_-_Saluda"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Analgesia_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío_1_Analgesia_-_Escucha_y_pregunta'] === "A"} title={"002._Desafío_1_Analgesia_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Analgesia_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío_1_Analgesia_-_Escucha_y_pregunta'] === "A"} title={"003._Desafío_1_Analgesia_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Analgesia_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío_1_Analgesia_-_Resuelve_su_necesidad'] === "A"} title={"004._Desafío_1_Analgesia_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Analgesia_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío_1_Analgesia_-_Resuelve_su_necesidad'] === "A"} title={"005._Desafío_1_Analgesia_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Analgesia_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío_1_Analgesia_-_Cierre_de_venta'] === "A"} title={"006._Desafío_1_Analgesia_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Analgesia_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío_1_Analgesia_-_Cierre_de_venta'] === "A"} title={"007._Desafío_1_Analgesia_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Analgesia_-_Agradece']} correct={dataFilterPerUser[pageSelected]?.['008._Desafío_1_Analgesia_-_Agradece'] === "A"} title={"008._Desafío_1_Analgesia_-_Agradece"}></CubeIntent>

                            </div>
                        </div>
                        {/* previo a utilizar  */}
                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>3x2</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío_2_3x2_-_Saluda']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío_2_3x2_-_Saluda'] === "A"} title={"001._Desafío_2_3x2_-_Saluda"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío_2_3x2_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío_2_3x2_-_Escucha_y_pregunta'] === "A"} title={"002._Desafío_2_3x2_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío_2_3x2_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío_2_3x2_-_Escucha_y_pregunta'] === "A"} title={"003._Desafío_2_3x2_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío_2_3x2_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío_2_3x2_-_Resuelve_su_necesidad'] === "A"} title={"004._Desafío_2_3x2_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío_2_3x2_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío_2_3x2_-_Cierre_de_venta'] === "A"} title={"005._Desafío_2_3x2_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío_2_3x2_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío_2_3x2_-_Cierre_de_venta'] === "A"} title={"006._Desafío_2_3x2_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío_2_3x2_-_Agradece']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío_2_3x2_-_Agradece'] === "A"} title={"007._Desafío_2_3x2_-_Agradece"}></CubeIntent>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                            </div>
                        </div>
                        {/* despliegue */}
                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>Receta médica</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío__3_-_Saluda']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío__3_-_Saluda'] === "A"} title={"001._Desafío__3_-_Saluda"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío__3_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío__3_-_Escucha_y_pregunta'] === "A"} title={"002._Desafío__3_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío__3_-_Escucha_y_pregunta']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío__3_-_Escucha_y_pregunta'] === "A"} title={"003._Desafío__3_-_Escucha_y_pregunta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío__3_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío__3_-_Resuelve_su_necesidad'] === "A"} title={"004._Desafío__3_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío__3_-_Resuelve_su_necesidad']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío__3_-_Resuelve_su_necesidad'] === "A"} title={"005._Desafío__3_-_Resuelve_su_necesidad"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío__3_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío__3_-_Cierre_de_venta'] === "A"} title={"006._Desafío__3_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío__3_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío__3_-_Cierre_de_venta'] === "A"} title={"007._Desafío__3_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['008._Desafío__3_-_Agradece']} correct={dataFilterPerUser[pageSelected]?.['008._Desafío__3_-_Agradece'] === "A"} title={"008._Desafío__3_-_Agradece"}></CubeIntent>

                            </div>
                        </div>
                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>Desafío_2</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío_2_3x2_-_Saluda,_escucha_y_atiende']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío_2_3x2_-_Saluda,_escucha_y_atiende'] === "A"} title={"001._Desafío_2_3x2_-_Saluda,_escucha_y_atiende"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío_2_3x2_-_Saluda,_escucha_y_atiende']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío_2_3x2_-_Saluda,_escucha_y_atiende'] === "A"} title={"002._Desafío_2_3x2_-_Saluda,_escucha_y_atiende"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío_2_3x2_-_Pregunta,_utiliza_y_menciona']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío_2_3x2_-_Pregunta,_utiliza_y_menciona'] === "A"} title={"003._Desafío_2_3x2_-_Pregunta,_utiliza_y_menciona"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío_2_3x2_-_Pregunta,_utiliza_y_menciona']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío_2_3x2_-_Pregunta,_utiliza_y_menciona'] === "A"} title={"004._Desafío_2_3x2_-_Pregunta,_utiliza_y_menciona"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío_2_3x2_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío_2_3x2_-_Cierre_de_venta'] === "A"} title={"005._Desafío_2_3x2_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío_2_3x2_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío_2_3x2_-_Cierre_de_venta'] === "A"} title={"006._Desafío_2_3x2_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío_2_3x2_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío_2_3x2_-_Cierre_de_venta'] === "A"} title={"007._Desafío_2_3x2_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['008._Desafío_2_3x2_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['008._Desafío_2_3x2_-_Cierre_de_venta'] === "A"} title={"008._Desafío_2_3x2_-_Cierre_de_venta"}></CubeIntent>                                

                            </div>
                        </div>
                        <div className='w-full flex py-2'>
                            <div className='w-4/12 flex justify-start items-center px-2'>
                                <p className='text-xs font-medium text-[#686868]'>_Desafío_3_</p>
                            </div>
                            <div className='w-8/12 flex justify-center gap-2'>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['001._Desafío_3_-_Saluda,_escucha_y_atiende']} correct={dataFilterPerUser[pageSelected]?.['001._Desafío_3_-_Saluda,_escucha_y_atiende'] === "[Sin texto A]"} title={'001._Desafío_3_-_Saluda,_escucha_y_atiende'}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['002._Desafío_3_-_Saluda,_escucha_y_atiende']} correct={dataFilterPerUser[pageSelected]?.['002._Desafío_3_-_Saluda,_escucha_y_atiende'] === "A"} title={"002._Desafío_3_-_Saluda,_escucha_y_atiende"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['003._Desafío_3_-_Pregunta,_utiliza_y_menciona']} correct={dataFilterPerUser[pageSelected]?.['003._Desafío_3_-_Pregunta,_utiliza_y_menciona'] === "A"} title={"003._Desafío_3_-_Pregunta,_utiliza_y_menciona"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['004._Desafío_3_-_Pregunta,_utiliza_y_menciona']} correct={dataFilterPerUser[pageSelected]?.['004._Desafío_3_-_Pregunta,_utiliza_y_menciona'] === "A"} title={"004._Desafío_3_-_Pregunta,_utiliza_y_menciona"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['005._Desafío_3_-_Pregunta,_utiliza_y_menciona']} correct={dataFilterPerUser[pageSelected]?.['005._Desafío_3_-_Pregunta,_utiliza_y_menciona'] === "A"} title={"005._Desafío_3_-_Pregunta,_utiliza_y_menciona"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['006._Desafío_3_-_Pregunta,_utiliza_y_menciona']} correct={dataFilterPerUser[pageSelected]?.['006._Desafío_3_-_Pregunta,_utiliza_y_menciona'] === "A"} title={"006._Desafío_3_-_Pregunta,_utiliza_y_menciona"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['007._Desafío_3_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['007._Desafío_3_-_Cierre_de_venta'] === "A"} title={"007._Desafío_3_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['008._Desafío_3_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['008._Desafío_3_-_Cierre_de_venta'] === "A"} title={"008._Desafío_3_-_Cierre_de_venta"}></CubeIntent>
                                <CubeIntent exist={dataFilterPerUser[pageSelected]?.['009._Desafío_3_-_Cierre_de_venta']} correct={dataFilterPerUser[pageSelected]?.['009._Desafío_3_-_Cierre_de_venta'] === "A"} title={"009._Desafío_3_-_Cierre_de_venta"}></CubeIntent>

                            </div>
                        </div>
                        {/*  */}

                        {/*  */}
                    </div>
                </div>
                {/*  */}
                {
                    dataFilterPerUser.length >= 2 &&
                    <div
                        onClick={() => { onchangePage(1) }}
                        className='h-full flex justify-center items-center pl-4 cursor-pointer'>
                        <div className='w-10 h-10 rounded-full shadowBtnNext flex justify-center items-center'>
                            <img src={icons.mayorqueicon} className='h-6 ' alt="" />
                        </div>
                    </div>
                }
            </div>
            <div className='w-full flex justify-center gap-x-2 pt-4'>
                {dataFilterPerUser.length >= 2 && <PageViewer pageSelected={pageSelected} dataFilterPerUser={dataFilterPerUser.length}></PageViewer>}

            </div>
        </div>
    )
}


const PageViewer = ({ pageSelected, dataFilterPerUser }) => {
    const rows = []
    for (let index = 0; index < dataFilterPerUser; index++) {
        rows.push(
            <div key={index} className={`w-2 h-2 
                ${pageSelected === index ? "bg-[#14A6E0] bg-opacity-100" : "bg-black bg-opacity-40"}
                 rounded-full`}></div>
        )
    }
    return rows
}

const InfoUser = ({ title, text }) => {
    return (
        <div className='w-2/6 h-full flex items-center'>
            <p className='text-[#686868]  text-xs font-medium leading-5'>{title}: </p>
            <p className='text-[#454545] text-xs font-normal pl-2 leading-5'>{text}</p>
        </div>
    )
}

const CubeIntent = ({ exist, correct, title }) => {
    let color = "bg-gray-200"
    if (exist) {
        color = correct ? 'bg-[#89EB7E]' : 'bg-[#DF3C3C]'
    }
    return (
        <Tooltip placement="rightTop" title={
            <div className='bg-[#2A3A45]'>
                <p className='text-white'>{title}</p>
            </div>
        } color="#2A3A45" overlayInnerStyle={{ color: "#2A3A45" }}>

            <div className={`w-6 h-6 cursor-pointer rounded-[4px] flex justify-center items-center text-xs text-white font-semibold
                                    ${color}`}>

            </div>
        </Tooltip>
    )
}


const InfoIntent = ({ icon, title, data }) => {
    return (
        <div className='flex gap-2'>
            <img src={icon} className="w-6 h-6" alt="icono de fecha" />
            <div>
                <p className='text-[#686868] text-xs font-medium leading-5'>{title}</p>
                <p className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>{data}</p>
            </div>
        </div>
    )
}


export default UserPerfilSimiVR
